





















































































import Vue from 'vue';

import Movie from '@/models/soukai/Movie';

import Storage from '@/utils/Storage';

import { MenuOption } from '@/components/base/BaseMenu.vue';
import ImportMediaModal from '@/components/modals/ImportMediaModal.vue';
import MoviesGrid from '@/components/MoviesGrid.vue';
import SeedCollectionModal from '@/components/modals/SeedCollectionModal.vue';

const MAX_MOVIES = 10;
const MAX_ROWS = 3;

const enum Sorting {
    MostRecent = 'most-recent',
    Oldest = 'oldest',
}

interface SortMenuOption extends MenuOption {
    sorting: Sorting;
}

interface Data {
    sorting: Sorting;
    gridColumns: number | null;
    resizeListener: (() => void) | null;
}

export default Vue.extend({
    components: {
        MoviesGrid,
    },
    data: (): Data => ({
        sorting: Storage.get('media-kraken-home-sorting', Sorting.MostRecent),
        gridColumns: null,
        resizeListener: null,
    }),
    computed: {
        sortingOptions(): SortMenuOption[] {
            const handle = ({ sorting }: SortMenuOption) => {
                this.sorting = sorting;

                Storage.set('media-kraken-home-sorting', sorting);
            };

            return [
                { sorting: Sorting.MostRecent, text: 'Most recent first', icon: 'hot', handle },
                { sorting: Sorting.Oldest, text: 'Oldest first', icon: 'hour-glass', handle },
            ];
        },
        sortingText(): string {
            return this.sortingOptions.find(option => option.sorting === this.sorting)!.text;
        },
        pendingMovies(): Movie[] {
            const pendingMovies = this.$media.movies.filter(movie => movie.pending);

            pendingMovies.sort((a: Movie, b: Movie) => a.createdAt.getTime() - b.createdAt.getTime());

            if (this.sorting === Sorting.MostRecent) {
                pendingMovies.reverse();
            }

            return pendingMovies;
        },
        pendingMoviesSummary(): Movie[] {
            const gridColumns = this.gridColumns || MAX_MOVIES;
            const moviesCount = Math.min(MAX_MOVIES - (MAX_MOVIES % gridColumns), MAX_ROWS * gridColumns);

            return this.pendingMovies.slice(0, moviesCount);
        },
    },
    mounted() {
        this.gridColumns = this.measureGridColumns();

        window.addEventListener('resize', this.resizeListener = () => this.gridColumns = this.measureGridColumns());
    },
    destroyed() {
        if (!this.resizeListener)
            return;

        window.removeEventListener('resize', this.resizeListener);
    },
    methods: {
        importMedia() {
            this.$ui.openModal(ImportMediaModal);
        },
        seedCollection() {
            this.$ui.openModal(SeedCollectionModal);
        },
        measureGridColumns(): number | null {
            const gridElement = (this.$refs['movies-grid'] as Vue)?.$el.querySelector('.grid');
            const movieElement = gridElement?.firstElementChild;

            return gridElement && movieElement
                ? Math.floor(gridElement.clientWidth / movieElement.clientWidth)
                : null;
        },
    },
});
